import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";
import CustomUploadAdapterPlugin from "components/admin/ckeditor/UploadAdapter";

const EditVisi = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [type, setType] = useState("image");
  const [imageUrl, setImageUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/api_w/abouts/${id}`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        setTitle(response.data.data?.title || "");
        setBody(response.data.data?.body || "");
        const url = response.data.data?.image_url || "";
        setImageUrl(url);
        setVideoUrl(url);
        if (url) {
          if (url.match(/\.(jpeg|jpg|gif|png|svg)$/)) {
            setType("image");
          } else if (
            url.includes("youtube.com") ||
            url.includes("youtu.be") ||
            url.includes("drive.google.com")
          ) {
            setType("video");
          }
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    };

    fetchData();
  }, [id]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(`/api_w/upload/single`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        const uploadedImageUrl = response.data.data.Location;
        setImageUrl(uploadedImageUrl);
        setVideoUrl("");
      } catch (error) {
        toast.error(
          "Error Upload Gambar: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const data = {
        title,
        body,
        image_url: type === "image" ? imageUrl : videoUrl,
      };
      const response = await axios.put(`/api_w/abouts/${id}`, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      console.log(response.data.data);
      toast.success(`Berhasil Edit ${title}!`);
      navigate("/admin/visi");
    } catch (error) {
      toast.error(
        `Error Edit ${title}: ` +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="container mx-auto p-5">
      <div className="mb-4">
        <label className="text-md block font-bold text-gray-800 dark:text-white">
          Judul
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="mt-1 block w-full rounded border border-gray-300 p-2"
          readOnly
        />
      </div>
      <div className="mb-4">
        <label className="text-md block font-bold text-gray-800 dark:text-white">
          Isi Visi
        </label>
        <CKEditor
          editor={ClassicEditor}
          config={{ extraPlugins: [CustomUploadAdapterPlugin] }}
          data={body}
          onChange={(event, editor) => {
            const data = editor.getData();
            setBody(data);
          }}
        />
      </div>
      <div className="mt-4">
        <label className="text-md block font-bold text-gray-800 dark:text-white">
          Type
        </label>
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
        >
          <option value="image">Gambar</option>
          <option value="video">Video</option>
        </select>
      </div>
      {type === "image" ? (
        <div className="mt-4">
          <label className="text-md block font-bold text-gray-800 dark:text-white">
            Gambar
          </label>
          {imageUrl && (
            <img
              src={imageUrl}
              alt="image_url"
              className="mb-2 mt-2 h-36 w-36"
            />
          )}
          <input
            type="file"
            onChange={handleFileChange}
            className="dark:text-white"
          />
          <span className="ml-1 mt-1 block text-xs text-gray-600">
            *Max size: 2MB, Format: .png, .jpg, .jpeg, .svg, .webp
          </span>
        </div>
      ) : (
        <div className="mt-4">
          <label className="text-md block font-bold text-gray-800 dark:text-white">
            Link Video
          </label>
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            placeholder="Masukkan Link video"
            className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
          />
        </div>
      )}
      <div className="mt-4 flex justify-end gap-4">
        <button
          type="button"
          className="rounded bg-red-500 px-4 py-2 font-bold text-white"
          onClick={() => navigate("/admin/visi")}
        >
          Batal
        </button>
        <button
          type="button"
          className="rounded bg-blue-500 px-4 py-2 font-bold text-white"
          onClick={handleSubmit}
        >
          Edit
        </button>
      </div>
    </div>
  );
};

export default EditVisi;
 